import { DetailedHTMLProps, FC, forwardRef, HTMLAttributes, SVGProps } from 'react';

import { classNames } from '@/utils';

import { TIKTOK_BUSINESS, X } from '@/lib/socialProfile';

export type SvgComponent = FC<SVGProps<SVGSVGElement>>;

export type IconProps = DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
    className?: string;
    icon: string | SvgComponent;
};

const Icon = forwardRef<HTMLSpanElement, IconProps>(
    ({ icon, className = '', ...restProps }, ref) => {
        if (typeof icon === 'function') {
            const SvgIcon = icon;
            const { style, ...spanProps } = restProps;
            return (
                <span ref={ref} className={className} {...spanProps}>
                    <SvgIcon aria-hidden className={className} style={style} />
                </span>
            );
        }

        if (typeof icon !== 'string') {
            return null;
        }

        let displayedIcon = icon;

        if (icon === TIKTOK_BUSINESS) {
            displayedIcon = 'tiktok';
        } else if (icon === X) {
            displayedIcon = 'twitter';
        }

        return (
            <i
                ref={ref}
                className={classNames(`icon-${displayedIcon}`, className)}
                {...restProps}
            />
        );
    }
);

Icon.displayName = 'Icon';

export default Icon;
